var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgMail(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 13,
    height: 10,
    viewBox: "0 0 13 10",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M11.5 0H1.5C0.810625 0 0.25 0.560625 0.25 1.25V8.75C0.25 9.43937 0.810625 10 1.5 10H11.5C12.1894 10 12.75 9.43937 12.75 8.75V1.25C12.75 0.560625 12.1894 0 11.5 0ZM11.5 1.25V1.56938L6.5 5.45875L1.5 1.57V1.25H11.5ZM1.5 8.75V3.1525L6.11625 6.74312C6.22569 6.82909 6.36083 6.87582 6.5 6.87582C6.63917 6.87582 6.77431 6.82909 6.88375 6.74312L11.5 3.1525L11.5013 8.75H1.5Z",
    fill: "#637381"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMail);
export default __webpack_public_path__ + "static/media/mail.5fcf0a40635aa086b3f5e136289616b7.svg";
export { ForwardRef as ReactComponent };